import { AdminRoles, BpAdminRoles } from '@bp/pim-auth-constants';
import i18next from 'i18next';

export function getAdminRoleTranslation(role: string): string {
  switch (role) {
    case AdminRoles.ShadowAdmin:
      return i18next.t('adminRoles.shadowAdmin');
    case AdminRoles.CollaborationAdmin:
      return i18next.t('adminRoles.collaborationAdmin');
    case AdminRoles.GroupAdmin:
      return i18next.t('adminRoles.groupAdmin');
    case AdminRoles.ProfileAdmin:
      return i18next.t('adminRoles.profileAdmin');
    case BpAdminRoles.ThreemaAdmin:
      return i18next.t('adminRoles.threemaAdmin');
    case AdminRoles.OrganizationAdmin:
      return i18next.t('adminRoles.schoolAdmin');
    case BpAdminRoles.CloudAdmin:
      return i18next.t('adminRoles.cloudAdmin');
    case BpAdminRoles.ZoomAdmin:
      return i18next.t('adminRoles.zoomAdmin');
    case BpAdminRoles.ImportAdmin:
      return i18next.t('adminRoles.importAdmin');
    case BpAdminRoles.SchoolOffice:
      return i18next.t('adminRoles.schoolOffice');
    default:
      return '';
  }
}
